export const TOGGLE_ATTRIBUTES = [
  { key: "show_in_person_products", adminOnly: false },
  { key: "allow_video_message_addon", adminOnly: true },
  { key: "allow_video_recording_addon", adminOnly: true },
  { key: "show_events", adminOnly: true },
  { key: "on_homepage", adminOnly: true },
  { key: "featured", adminOnly: true },
  {
    key: "is_franchise",
    displayName: "Franchise",
    adminOnly: true,
    groupShopOnly: true,
  },
  {
    key: "is_character",
    displayName: "Character",
    adminOnly: true,
    groupShopOnly: true,
  },
  {
    key: "is_stripe_payout",
    displayName: "Autopay",
    adminOnly: true,
  },
  { key: "is_agent", adminOnly: true },
  { key: "is_talent_coordinator", adminOnly: true },
  { key: "is_nmt", adminOnly: true },
  {
    key: "is_manual_shop_status",
    displayName: "Manual Shop Open/Close Status",
    adminOnly: true,
  },
  {
    key: "show_artists",
    displayName: "Show Artists",
    groupShopOnly: true,
    adminOnly: true,
  },
  {
    key: "show_price_disclaimer",
    displayName: "Show Price Disclaimer",
    nonGroupShopOnly: true,
    adminOnly: true,
  },
  {
    key: "is_cameo_participant",
    displayName: "Cameo Participant",
    adminOnly: true,
    nonGroupShopOnly: true,
  },
  {
    key: "is_legacy_shop",
    displayName: "Use Legacy UI",
    adminOnly: true,
  },
];
